import { createContext } from 'react';

const PageContext = createContext<{
  site: Site;
  pages: Array<Page>;
  page: Page;
}>(undefined);

export default PageContext;
